import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useState, useCallback } from "react"

import {
  AuthenticateContent,
  AuthenticateModalTitle,
  Footnote,
} from "areas/authenticate/components"
import Modal, { closeModal } from "components/modal"
import Image from "components/ui/image"
import Media from "components/ui/media"
import { jewlr_t, retry } from "helpers/application"
import { to_currency } from "helpers/number"
import withAuth from "hoc/account/with-auth"

const RegisterForm = loadable(() =>
  retry(() => import("areas/authenticate/register-form"))
)

const ReferralRegister = ({ referralName }) => {
  const [showContent, setShowContent] = useState(false)
  const afterShow = useCallback(() => {
    setShowContent(true)
  })
  return (
    <Modal
      afterShow={afterShow}
      ariaLabel="Create an account"
      contentClassName="p-0 tablet:p-0"
      headerVariant="float"
      onClose={closeModal}
      show="#referral"
    >
      {showContent && (
        <AuthenticateContent>
          <Media
            className="bg-light-pink flex flex-col justify-center px-16 py-32"
            greaterThanOrEqual="tablet"
            style={{ flexBasis: "360px" }}
          >
            <h3 className="text-30 mb-16 text-center font-light">
              You&apos;ll get a {to_currency(20)} in Jewls
              {!!referralName && ` from ${referralName}`}!
            </h3>
            <ul className="list-none">
              <li className="text-18 mb-20 flex items-center font-light">
                <span className="text-primary h-30 w-30 mr-20 inline-flex items-center justify-center rounded-full bg-white p-5">
                  1
                </span>{" "}
                <span className="flex-1 text-left">
                  Welcome! Create your Jewlr account
                </span>
              </li>
              <li className="text-18 mb-20 flex items-center font-light">
                <span className="text-primary h-30 w-30 mr-20 inline-flex items-center justify-center rounded-full bg-white p-5">
                  2
                </span>{" "}
                <span className="flex-1 text-left">
                  Check your email for an exclusive 15% offer
                </span>
              </li>
              <li className="text-18 mb-20 flex items-center font-light">
                <span className="text-primary h-30 w-30 mr-20 inline-flex items-center justify-center rounded-full bg-white p-5">
                  3
                </span>{" "}
                <span className="flex-1 text-left">
                  Enjoy shopping for {jewlr_t("terms.personalized")}{" "}
                  {jewlr_t("terms.jewelry")}
                </span>
              </li>
              <li className="text-18 mb-20 flex items-center font-light">
                <span className="text-primary h-30 w-30 mr-20 inline-flex items-center justify-center rounded-full bg-white p-5">
                  4
                </span>{" "}
                <span className="flex-1 text-left">
                  Receive {to_currency(20)} in Jewls with your first purchase
                </span>
              </li>
            </ul>
            <Image
              alt=""
              className="mx-auto pt-48"
              height="58px"
              src={require("images/account/jewel_group.svg")}
              width="82px"
            />
          </Media>
          <div className="max-w-375 tablet:px-16 desktop:px-24 m-auto flex-1 px-24">
            <AuthenticateModalTitle>Create an account</AuthenticateModalTitle>
            <RegisterForm />
            <Footnote className="mt-24">
              Please note only new members qualify for referral bonus rewards.
            </Footnote>
          </div>
        </AuthenticateContent>
      )}
    </Modal>
  )
}

ReferralRegister.propTypes = {
  referralName: PropTypes.string,
}

export default withAuth(ReferralRegister)
